var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "cases",
    style: _vm.caseStyle
  }, [_c("div", {
    staticClass: "cases_content"
  }, [_vm.showCase ? _c("Title", {
    staticClass: "cases_content_case",
    attrs: {
      title: _vm.caseTitle
    }
  }) : _vm._e(), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showTitle,
      expression: "showTitle"
    }],
    staticClass: "cases_content_title",
    style: _vm.paddingStyle
  }, [_vm.source === "mobileTerminal" ? _c("span", [_vm._v(" The common choice of "), _c("a", [_vm._v("88")]), _vm._v(" securities brokers, provide more than "), _c("a", [_vm._v("2000")]), _vm._v(" functions. ")]) : _vm.source === "aiProduct" ? _c("span", [_vm._v(" 我们的AI技术已经服务于全球 "), _c("a", [_vm._v("1,000")]), _vm._v(" "), _c("br"), _vm._v("企业 ")]) : _vm.source === "pcTerminal" ? _c("span", [_vm._v(" Chose by "), _c("a", [_vm._v("90%")]), _vm._v(" of securities companies, provide more than "), _c("a", [_vm._v("750")]), _vm._v(" functions ")]) : _c("span", [_vm._v(" Covering "), _c("a", [_vm._v("96%")]), _vm._v(" of securities companies and "), _c("a", [_vm._v("91%")]), _vm._v(" of fund companies ")])]), _vm.casesText ? _c("div", {
    staticClass: "cases_content_text",
    style: _vm.textStyle
  }, [_vm._v(_vm._s(_vm.casesText))]) : _vm._e()], 1), _c("div", {
    staticClass: "cases_broker",
    style: _vm.brokerStyle
  }, [_c("div", {
    staticClass: "cases_broker_cont",
    style: _vm.bgStyle
  })])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };